
import React from "react";
import { 
  FileText, Bookmark, Clock, Library, Cpu, BarChart 
} from "lucide-react";

const features = [
  {
    icon: <FileText className="h-10 w-10 text-lawyer-secondary" />,
    title: "Prompts por Área",
    description: "Acesse prompts específicos para Trabalhista, Cível, Contratual e diversas outras áreas do Direito."
  },
  {
    icon: <Bookmark className="h-10 w-10 text-lawyer-secondary" />,
    title: "Templates Otimizados",
    description: "Prompts testados e refinados para obter os melhores resultados com modelos de linguagem IA."
  },
  {
    icon: <Clock className="h-10 w-10 text-lawyer-secondary" />,
    title: "Economia de Tempo",
    description: "Reduza o tempo de redação e pesquisa com instruções de IA já estruturadas para necessidades jurídicas."
  },
  {
    icon: <Library className="h-10 w-10 text-lawyer-secondary" />,
    title: "Biblioteca Expansível",
    description: "Novos prompts adicionados regularmente com base em feedback de usuários e mudanças na legislação."
  },
  {
    icon: <Cpu className="h-10 w-10 text-lawyer-secondary" />,
    title: "Impulsionado por Inteligência Artificial",
    description: "Desenvolvido com tecnologia de ponta para compreender e atender às necessidades reais da prática jurídica diária, com base em dados e padrões analisados por IA."
  },
  {
    icon: <BarChart className="h-10 w-10 text-lawyer-secondary" />,
    title: "Estatísticas de Uso",
    description: "Acompanhe quais prompts você utiliza mais e otimize seu fluxo de trabalho."
  }
];

const Features = () => {
  return (
    <section className="py-16 bg-white dark:bg-gray-900">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold font-display mb-4 dark:text-white">Recursos Exclusivos</h2>
          <p className="text-gray-600 max-w-xl mx-auto dark:text-gray-400">
            Nossa plataforma foi desenvolvida pensando nas necessidades específicas dos profissionais do Direito.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="bg-white rounded-lg p-8 shadow-md hover:shadow-lg transition-shadow border border-gray-100 card-hover dark:bg-gray-800 dark:border-gray-700"
            >
              <div className="mb-4">{feature.icon}</div>
              <h3 className="text-xl font-semibold mb-2 text-lawyer-primary dark:text-lawyer-secondary">{feature.title}</h3>
              <p className="text-gray-600 dark:text-gray-300">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
